import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../master_root/header';
import { db } from "../firebase";
import { doc, setDoc, getDocs, query, collection, where } from "firebase/firestore";
import { useNavigate } from 'react-router-dom'; 
import Cookies from 'js-cookie'; 
import './live.css';
import { Randomcode } from '../components/rendom_code';

export default function Live() {
  const [name, setName] = useState('');
  const [target, setTarget] = useState('');
  const [otp, setOtp] = useState('');
  const [generatedOtp, setGeneratedOtp] = useState('');
  const [joined, setJoined] = useState(false);
  const localVideo = useRef(null);
  const peerConnection = useRef(null);
  const ws = useRef(null);
  const [remoteStreams, setRemoteStreams] = useState([]);
  const navigate = useNavigate();
  const [guid, setGuid] = useState("");
  const [loginisOpen, setLoginIsOpen] = useState(false);

  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser) {
      setGuid(existingUser);
      setName(Cookies.get("name"));
      setLoginIsOpen(true);
    } else {
      setLoginIsOpen(false);
    }
  }, []);

  useEffect(() => {
    const WS_URL = process.env.REACT_APP_WS_URL || "wss://your-server.com/ws";
    ws.current = new WebSocket(WS_URL);

    ws.current.onmessage = async ({ data }) => {
      const message = JSON.parse(data);

      switch (message.type) {
        case 'offer':
          if (!peerConnection.current) return;
          await peerConnection.current.setRemoteDescription(new RTCSessionDescription(message.offer));
          const answer = await peerConnection.current.createAnswer();
          await peerConnection.current.setLocalDescription(answer);
          ws.current.send(JSON.stringify({ type: 'answer', answer, target: message.name }));
          break;

        case 'answer':
          if (!peerConnection.current) return;
          await peerConnection.current.setRemoteDescription(new RTCSessionDescription(message.answer));
          break;

        case 'candidate':
          if (peerConnection.current && message.candidate) {
            await peerConnection.current.addIceCandidate(new RTCIceCandidate(message.candidate));
          }
          break;

        default:
          break;
      }
    };

    // Cleanup on unmount
    return () => {
      if (ws.current) ws.current.close();
      if (peerConnection.current) peerConnection.current.close();
    };
  }, []);

  const generateOTP = () => Math.floor(100000 + Math.random() * 900000).toString();

  const initializePeerConnection = (stream) => {
    peerConnection.current = new RTCPeerConnection();

    stream.getTracks().forEach(track => peerConnection.current.addTrack(track, stream));

    peerConnection.current.ontrack = event => {
      const newStream = event.streams[0];
      setRemoteStreams(prev => {
        const alreadyAdded = prev.some(s => s.id === newStream.id);
        return alreadyAdded ? prev : [...prev, newStream];
      });
    };

    peerConnection.current.onicecandidate = event => {
      if (event.candidate) {
        ws.current.send(JSON.stringify({ type: 'candidate', candidate: event.candidate, target }));
      }
    };
  };

  const startNew = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      localVideo.current.srcObject = stream;

      initializePeerConnection(stream);

      const otpcode = generateOTP();
      const uid = Randomcode(15);
      setGeneratedOtp(otpcode);

      const docRef = doc(db, "liveStreams", uid);
      const savequery = {
        uid,
        otpcode,
        latitude: Cookies.get("latitude"),
        longitude: Cookies.get("longitude"),
        city: Cookies.get("City"),
        postcode: Cookies.get("Postcode"),
        state: Cookies.get("State"),
        Country: Cookies.get("Country"),
        guid: Cookies.get("guid"),
        update_date_time: new Date(),
        date_time: new Date(),
        device: navigator.userAgent,
        ip: Cookies.get("ipaddres"),
        status: true,
      };

      await setDoc(docRef, savequery);
      alert(`Share this OTP with your partner: ${otpcode}`);

      ws.current.send(JSON.stringify({ type: 'join', name }));
      setJoined(true);
    } catch (err) {
      console.error(err);
      alert("Camera/Mic permission denied or not found.");
    }
  };

  const joinWithOtp = async () => {
    try {
      const joinQuery = query(
        collection(db, "liveStreams"),
        where("otpcode", "==", otp),
        where("status", "==", true)
      );
      const querySnapshot = await getDocs(joinQuery);

      if (querySnapshot.empty) {
        alert("Target stream not found.");
        return;
      }

      const streamData = querySnapshot.docs[0].data();
      if (streamData.otpcode !== otp) {
        alert("Invalid OTP.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      localVideo.current.srcObject = stream;
      setTarget(streamData.guid || streamData.uid);

      initializePeerConnection(stream);

      const joinuid = Randomcode(15);
      const docRef = doc(db, "liveStreams", joinuid);
      const savequery = {
        otpcode: streamData.otpcode,
        uid: joinuid,
        uidlivewith: streamData.uid,
        latitude: Cookies.get("latitude"),
        longitude: Cookies.get("longitude"),
        city: Cookies.get("City"),
        postcode: Cookies.get("Postcode"),
        state: Cookies.get("State"),
        Country: Cookies.get("Country"),
        guid: Cookies.get("guid"),
        update_date_time: new Date(),
        date_time: new Date(),
        device: navigator.userAgent,
        ip: Cookies.get("ipaddres"),
        status: true,
      };

      await setDoc(docRef, savequery);
      alert(`You're connected to ${streamData.uid}`);

      const offer = await peerConnection.current.createOffer();
      await peerConnection.current.setLocalDescription(offer);
      ws.current.send(JSON.stringify({ type: 'offer', offer, name, target: streamData.guid || streamData.uid }));

      setJoined(true);
    } catch (error) {
      console.error(error);
      alert("Error joining: " + error.message);
    }
  };

  return (
    <div>
      <Header />
      <div className='app_header_height'></div>
      <div className="container_roots">
        <Helmet>
          <title>Live Streaming | EditorTask - Connect & Collaborate</title>
          <meta name="description" content="Go live and stream with your team or clients in real-time using EditorTask's peer-to-peer streaming." />
          <meta name="keywords" content="live stream, video collaboration, editor live, realtime chat, work with editors" />
        </Helmet>

        {loginisOpen ? (
          <div className="container_size">
            <div className='post-container'>
              <div className="contact-title">Live Streaming | Connect Now</div>
            </div>

            <div className='post-container'>
              <div className='post_updates row_body'> 
                <input className="input" placeholder="Enter OTP (if joining)" value={otp} onChange={e => setOtp(e.target.value)} /> 
                {!joined ? (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button className="btn" onClick={startNew}>Start New</button>
                    <button className="btn" onClick={joinWithOtp}>Join</button>
                  </div>
                ) : (
                  <p>You're connected. Waiting for peer.</p>
                )}

                {generatedOtp && (
                  <p><strong>Generated OTP:</strong> {generatedOtp}</p>
                )}

                <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
                  <video ref={localVideo} autoPlay muted playsInline width="300" style={{ border: '1px solid #ccc' }} />
                  {remoteStreams.map((stream, index) => (
                    <video key={index} autoPlay playsInline width="300"
                      ref={video => {
                        if (video) video.srcObject = stream;
                      }} style={{ border: '1px solid #ccc' }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container_size">
            <div className='post-container'>
              <div className="contact-title">Login to | Live Streaming | Connect Now</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
